import { render } from "./ReceiptCorrection.vue?vue&type=template&id=24a31250&scoped=true"
import script from "./ReceiptCorrection.vue?vue&type=script&lang=js"
export * from "./ReceiptCorrection.vue?vue&type=script&lang=js"

import "./ReceiptCorrection.vue?vue&type=style&index=0&id=24a31250&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a31250"]])

export default __exports__